import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import FetchFunc from "../API";
import close from "../asset/Close_round.png";
import "./Customerorders.css";

const EditGuestOrderModal = ({ id, closeModal,order }) => {   
    const navigate = useNavigate();
    const [emailLogs, setEmailLogs] = useState([]);
    const [emailLogsLoading, setEmailLogsLoading] = useState(false);
    const [emailLogsError, setEmailLogsError] = useState('');

    useEffect(() => {
        const fetchEmailLogs = async () => {
            setEmailLogsLoading(true);
            setEmailLogsError('');
            try {
                const response = await FetchFunc(
                    `/admin/order-email-logs?orderType=GUEST&orderId=${id}&limit=50`,
                    'GET',
                );
                if (response.status === 401 || response.status === 403) {
                    localStorage.setItem('isLoggedIn', false);
                    localStorage.removeItem('username');
                    localStorage.removeItem('role');
                    localStorage.removeItem('userId');
                    localStorage.removeItem('email');
                    localStorage.removeItem('mobile');
                    navigate('/adminlogin');
                    return;
                }
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setEmailLogs(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching email logs:', error);
                setEmailLogsError('Failed to load email logs');
            } finally {
                setEmailLogsLoading(false);
            }
        };
        fetchEmailLogs();
    }, [id, navigate]);

    const formatLogTime = (value) => {
        if (!value) {
            return '-';
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return value;
        }
        return date.toLocaleString();
    };

    return (
        <div className="change_modal">
            <div className="change_order_modal_content">
                <div className="close_modal">                    
                    <img src={close} alt="close" onClick={closeModal} />
                </div>
                <h1>Order: {id}</h1>
                <div className="order_payment_info">
                    <p><strong>Order Status:</strong> {order.currentStatus}</p>
                    {order.paymentStatus && (
                        <p><strong>Payment Status:</strong> {order.paymentStatus}</p>
                    )}
                    {order.amountPaid && (
                        <p><strong>Amount Paid:</strong> ${(order.amountPaid / 100).toFixed(2)}</p>
                    )}
                    {order.paymentIntentId && (
                        <p><strong>Payment Intent ID:</strong> {order.paymentIntentId}</p>
                    )}
                </div>
                <p>Address: {order.propertyAddress}</p>
                <p>Customer notes: {order.notes}</p>
                <div className="customer_order_detail_info">                    
                    <div className="order_detail_info">
                        <p>Customer: {order.firstName} {order.lastName}</p>
                        <p>Customer email: {order.email}</p>
                        <p>Customer mobile: {order.mobile}</p>
                        {order.secondContact === true &&
                            <p>Second Contact: {order.secondFirstName} {order.secondLastName}</p>
                        }
                    </div>
                    <div className="order_detail_info">
                        <p>Agent: {order.agentFirstName} {order.agentLastName}</p>
                        <p>Agent email: {order.agentEmail}</p>
                        <p>Agent mobile: {order.agentMobile}</p>
                    </div>
                </div>
                <div className="email_logs_section">
                    <h2>Email Logs</h2>
                    {emailLogsLoading && <p className="email_logs_hint">Loading email logs...</p>}
                    {!emailLogsLoading && emailLogsError && <p className="email_logs_error">{emailLogsError}</p>}
                    {!emailLogsLoading && !emailLogsError && emailLogs.length === 0 && (
                        <p className="email_logs_hint">暂无邮件记录</p>
                    )}
                    {!emailLogsLoading && !emailLogsError && emailLogs.length > 0 && (
                        <div className="email_logs_list">
                            {emailLogs.map((log, index) => (
                                <div className="email_logs_item" key={`${log.id || 'log'}-${index}`}>
                                    <div className="email_logs_top">
                                        <span className="email_logs_time">{formatLogTime(log.createdAt)}</span>
                                        <span className={log.status === 'SENT' ? 'email_logs_status_ok' : 'email_logs_status_fail'}>
                                            {log.status}
                                        </span>
                                    </div>
                                    <p>{log.recipientRole} - {log.recipientEmail}</p>
                                    <p>{log.templateCode} / {log.triggerSource}</p>
                                    {log.errorMessage && <p className="email_logs_error_text">{log.errorMessage}</p>}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const Guestorders = () => {
    const [order, setOrder] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const navigate = useNavigate();
    const [filter, setFilter] = useState('COMPLETED');
    const [activeOrderId, setActiveOrderId] = useState(null);
    const [id, setId] = useState('');
    const [address, setAddress] = useState('');
    const pageSize = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const [totalOrders, setTotalOrders] = useState(null);
    const totalPages = Math.ceil(totalOrders / pageSize);
    const [searchedOrder, setSearchedOrder] = useState([]);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                let response;
                if (filter) {
                    response = await FetchFunc(
                        `/admin/allGuestOrders?status=${filter}&offset=${currentPage-1}&limit=${pageSize}`,
                        'GET',
                    );
                } else {
                    response = await FetchFunc(
                        `/admin/allGuestOrders?offset=${currentPage-1}&limit=${pageSize}`,
                        'GET',
                    );
                }
                if (response.status === 401 || response.status === 403) {
                    localStorage.setItem('isLoggedIn', false);
                    localStorage.removeItem('username');
                    localStorage.removeItem('role');
                    localStorage.removeItem('userId');
                    localStorage.removeItem('email');
                    localStorage.removeItem('mobile');
                    navigate('/adminlogin');
                } else if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                // console.log('Response from server:', response);
                const data = await response.json();
                // console.log('data response:', data);
                setTotalOrders(data.totalElements);
                const sorted = data.content.slice().sort((a, b) => {
                    return new Date(b.createTime) - new Date(a.createTime);
                });
                setOrder(sorted);
            } catch (error) {
                console.error('Error fetching orders:', error);
            }
        };
        fetchOrders();
    }, [refresh, navigate, filter, currentPage, pageSize]);

    const formatToISO = (dateString) => {
        const [day, month, yearAndTime] = dateString.split('-');
        const [year, time] = yearAndTime.split(' ');
        return `${year}-${month}-${day}T${time}`;
    };

    const handleAddressSearch = (e) => {
        setAddress(e.target.value);
    }

    const handleIdSearch = (e) => {
        setId(e.target.value);
    }

    const handleSearch = async (e) => {
        e.preventDefault();
        const params = new URLSearchParams({
            orderId: id || '',
            address: address || '',
        });
        try {
            const response = await FetchFunc(
                `/admin/search/guestOrders?${params.toString()}`,
                'GET',
            );
            if (response.status === 401 || response.status === 403) {
                localStorage.setItem('isLoggedIn', false);
                localStorage.removeItem('username');
                localStorage.removeItem('role');
                localStorage.removeItem('userId');
                localStorage.removeItem('email');
                localStorage.removeItem('mobile');
                navigate('/adminlogin');
            } else if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = await response.json();
            // console.log('data response:', data);
            setSearchedOrder(data);
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const handleOpenModal = (orderId) => {
        // console.log(orderId)
        setActiveOrderId(orderId);
    };
    
    const handleCloseModal = () => {
        setActiveOrderId(null);
    };

    const handleRecordDownload = async () => {
        try {
            const response = await FetchFunc(
                '/admin/exportGuestOrders',
                'GET',
            );
            if (response.status === 401 || response.status === 403) {
                localStorage.setItem('isLoggedIn', false);
                localStorage.removeItem('username');
                localStorage.removeItem('role');
                localStorage.removeItem('userId');
                localStorage.removeItem('email');
                localStorage.removeItem('mobile');
                navigate('/adminlogin');
            } else if (!response.ok) {
                // console.log(response.text());
            }
            // console.log('Response from server:', response);
            const blob = await response.blob();

            // Create a temporary URL for the blob
            const downloadUrl = window.URL.createObjectURL(blob);
    
            // Create a link element and trigger the download
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = order.reportName || 'downloaded_file';
            document.body.appendChild(link);
            link.click();
    
            // Cleanup: Remove the link and revoke the URL
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
            
        } catch (error) {
            console.error('Failed to update password:', error);
        }
    };

    return (
        <div className="orders">
            <div className="change_property_title">
                <h1>Orders</h1>
                <button onClick={handleRecordDownload} style={{width: '15rem'}}>Download Order Record</button>
            </div>
            <hr style={{background: '#DDD', width: '100%', border: 'none', height: '1px'}} />
            <div className="order_search">
                <input 
                    type="text"
                    value={id}
                    placeholder="Search order id"
                    onChange={handleIdSearch}
                />
                <input
                    type="text"
                    value={address}
                    placeholder="Search address"
                    onChange={handleAddressSearch}                    
                />
                <button onClick={handleSearch}>Search</button>
            </div>
            <div className="order_status">
                <span 
                    onClick={() => setFilter('')}
                    className={filter === '' ? 'active' : ''}
                >All</span>
                <span 
                    onClick={() => setFilter('PENDING_PAYMENT')}
                    className={filter === 'PENDING_PAYMENT' ? 'active' : ''}
                >Pending Payment</span>
                <span 
                    onClick={() => setFilter('PAID')}
                    className={filter === 'PAID' ? 'active' : ''}
                >Paid</span>
                <span 
                    onClick={() => setFilter('PROCESSING')}
                    className={filter === 'PROCESSING' ? 'active' : ''}
                >Processing</span>
                <span 
                    onClick={() => setFilter('COMPLETED')}
                    className={filter === 'COMPLETED' ? 'active' : ''}
                >Completed</span>
                <span 
                    onClick={() => setFilter('CANCELLED')}
                    className={filter === 'CANCELLED' ? 'active' : ''}
                >Cancelled</span>
                <span 
                    onClick={() => setFilter('REFUNDED')}
                    className={filter === 'REFUNDED' ? 'active' : ''}
                >Refunded</span>
            </div>
            <div className="order_list">
                {Array.isArray(searchedOrder) && 
                    searchedOrder
                    .sort((a, b) => new Date(formatToISO(b.createTime)) - new Date(formatToISO(a.createTime)))
                    .map((order) => (
                    <div key={order.id} className="order_item">                        
                        <div className="order_detail">
                            <p>{order.createTime}</p>
                            <h1>Order #{order.id}</h1>
                            <h2>{order.propertyAddress}</h2>
                            <div className="order_status_info">
                                <p><strong>Order Status:</strong> {order.currentStatus}</p>
                                {order.paymentStatus && (
                                    <p><strong>Payment Status:</strong> {order.paymentStatus}</p>
                                )}
                                {order.amountPaid && (
                                    <p><strong>Amount Paid:</strong> ${(order.amountPaid / 100).toFixed(2)}</p>
                                )}
                                {order.paymentIntentId && (
                                    <p><strong>Payment ID:</strong> {order.paymentIntentId.substring(0, 20)}...</p>
                                )}
                            </div>
                        </div>
                        <div onClick={() => handleOpenModal(order.id)} className="edit_order">
                            Show Details
                        </div>
                        {activeOrderId === order.id && (
                            <EditGuestOrderModal 
                                id={order.id}
                                closeModal={handleCloseModal}
                                order={order}
                                refresh={refresh}
                                setRefresh={setRefresh}
                            />
                        )}
                    </div>
                ))}
                <hr style={{background: '#DDD', width: '100%', border: 'none', height: '1px'}} />
            </div>
            <div className="order_list">
                {order
                .sort((a, b) => new Date(formatToISO(b.createTime)) - new Date(formatToISO(a.createTime)))
                .map((order) => (
                    <div key={order.id} className="order_item">                        
                        <div className="order_detail">
                            <p>{order.createTime}</p>
                            <h1>Order #{order.id}</h1>
                            <h2>{order.propertyAddress}</h2>
                            <div className="order_status_info">
                                <p><strong>Order Status:</strong> {order.currentStatus}</p>
                                {order.paymentStatus && (
                                    <p><strong>Payment Status:</strong> {order.paymentStatus}</p>
                                )}
                                {order.amountPaid && (
                                    <p><strong>Amount Paid:</strong> ${(order.amountPaid / 100).toFixed(2)}</p>
                                )}
                                {order.paymentIntentId && (
                                    <p><strong>Payment ID:</strong> {order.paymentIntentId.substring(0, 20)}...</p>
                                )}
                            </div>
                        </div>
                        <div onClick={() => handleOpenModal(order.id)} className="edit_order">
                            Show details
                        </div>
                        {activeOrderId === order.id && (
                            <EditGuestOrderModal 
                                id={order.id}
                                closeModal={handleCloseModal}
                                order={order}
                            />
                        )}
                    </div>
                ))}
            </div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'end', alignItems: 'center', gap: '5px'}}>
                <button
                    onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                >
                    Last Page
                </button>
                {[...Array(totalPages)].map((_, idx) => {
                    const page = idx + 1;
                    return (
                        <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            style={{
                                fontWeight: page === currentPage ? 'bold' : 'normal',
                            }}
                        >
                            {page}
                        </button>
                    );
                })}
                <button
                    onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                    disabled={currentPage === totalPages}
                >
                    Next Page
                </button>
            </div>
        </div>
    );
};

export default Guestorders;
